import { createVanIconComponent } from "./van"

const Minus = createVanIconComponent("minus")
export default Minus
